import React from 'react';

import { Criterium, CriteriumCompetitors, CriteriumTrafficEngagement } from '@hydra/common/criterium';

import { CriteriumInterface, ReviewData } from '@hydra/types/review';

interface TrafficEngagement extends CriteriumInterface {
  data: {
    year?: number
    month?: number
    visits?: number
    timeOnSite?: number
    pagePerVisit?: number
    bounceRate?: number
    previousMonthVisits?: number
  }
}

export const TrafficEngagement = ({ criterium, competitors = [] }: { criterium: TrafficEngagement, competitors: Array<ReviewData> }) => {
  const { url } = criterium;
  const content = <CriteriumTrafficEngagement data={criterium.data} />;

  let compContent;
  if (competitors.length > 0) {
    const compComponents = [
      { component: content, url },
      ...competitors.map(({ criteria }) => {
        if (!criteria.traffic_engagement || !criteria.traffic_engagement.data) {
          return null;
        }
        const { data, url } = criteria.traffic_engagement;

        return {
          component: (
            <>
              <CriteriumTrafficEngagement data={data} />
            </>
          ),
          url
        };
      })
    ];
    compContent = <CriteriumCompetitors competitors={compComponents} />;
  }

  return <Criterium criterium={criterium}>{compContent || content}</Criterium>;
};

export default React.memo(TrafficEngagement);
